var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"d-flex flex-wrap mt-4"},_vm._l((_vm.pages),function(page,index){return _c('p',{key:index,class:{ 'font-weight-bold': index < _vm.pages.length - 1 }},[_c('span',{class:{
          'color-primary': index < _vm.pages.length - 1,
          'page-name': index < _vm.pages.length - 1,
        },on:{"click":function($event){return _vm.goToPage(page.link)}}},[_vm._v(_vm._s(page.name))]),(index < _vm.pages.length - 1)?_c('span',[_vm._v(" / ")]):_vm._e()])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }